// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const API = "https://api.propertygalleria.in/master/api";

// const GeoLocationPermission = () => {
//     const [leads, setLeads] = useState([]);
//     const [loading, setLoading] = useState(true);

//     // ✅ SAME GET API
//     const fetchLeads = async () => {
//         try {
//             const res = await axios.get(`${API}/investorLeads`);
//             setLeads(res.data);
//         } catch (err) {
//             console.error(err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchLeads();
//     }, []);

//     // ✅ PUT API CALL
//     const updateLocationPermission = async (id, currentValue) => {
//         try {
//             await axios.put(`${API}/leads/${id}/location-permission`, {
//                 enabled_location: currentValue === 1 ? 0 : 1,
//             });

//             alert("Updated successfully");

//             fetchLeads(); // refresh
//         } catch (err) {
//             console.error(err);
//             alert("Update failed");
//         }
//     };

//     return (
//         <div style={{ padding: "20px" }}>
//             <h2>Geolocation Permission</h2>

//             {loading ? (
//                 <p>Loading...</p>
//             ) : (
//                 <table border="1" cellPadding="10" style={{ width: "100%" }}>
//                     <thead>
//                         <tr>
//                             <th>Name</th>
//                             <th>Mobile</th>
//                             <th>Email</th>
//                             <th>Location Status</th>
//                             <th>Action</th>
//                         </tr>
//                     </thead>

//                     <tbody>
//                         {leads.map((lead) => (
//                             <tr key={lead.id}>
//                                 <td>{lead.full_name}</td>
//                                 <td>{lead.mobile_number}</td>
//                                 <td>{lead.email}</td>

//                                 <td>
//                                     {lead.enabled_location === 1
//                                         ? "Request Sent"
//                                         : "Waiting for Request"}
//                                 </td>

//                                 <td>
//                                     <button
//                                         onClick={() =>
//                                             updateLocationPermission(
//                                                 lead.id,
//                                                 lead.enabled_location
//                                             )
//                                         }
//                                     >
//                                         {lead.enabled_location === 1
//                                             ? "Mark Waiting"
//                                             : "Send Request"}
//                                     </button>
//                                 </td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//             )}
//         </div>
//     );
// };

// export default GeoLocationPermission;

import React, { useEffect, useState } from "react";
import axios from "axios";
import { Search } from "lucide-react";
import { useAdmin } from "../AdminLayout/AdminProvider";

const API = "https://api.propertygalleria.in/master/api";

const APII = "http://localhost:4001";

const GeoLocationPermission = () => {

    const { projects } = useAdmin();

    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    // const fetchLeads = async () => {
    //     try {
    //         const res = await axios.get(`${API}/investorLeads`);
    //         setLeads(res.data);
    //     } catch (err) {
    //         console.error(err);
    //     } finally {
    //         setLoading(false);
    //     }
    // };


    const fetchLeads = async () => {
        try {
            const res = await axios.get(`${API}/investorLeads`);

            // ✅ SORT BY ID (latest first)
            const sortedData = res.data.sort((a, b) => b.id - a.id);

            setLeads(sortedData);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchLeads();
    }, []);

    const updateLocationPermission1 = async (id, currentValue) => {
        try {
            await axios.put(`${API}/leads/${id}/location-permission`, {
                enabled_location: currentValue === 1 ? 0 : 1,
            });

            fetchLeads();
        } catch (err) {
            console.error(err);
            alert("Update failed");
        }
    };


    const updateLocationPermission = async (id, currentValue) => {
        try {
            const newValue = currentValue === 1 ? 0 : 1;

            await axios.put(`${API}/leads/${id}/location-permission`, {
                enabled_location: newValue,
            });

            // ✅ SUCCESS ALERT
            alert("✅ Location permission updated successfully");

            // ✅ INSTANT UI UPDATE (no refresh needed)
            setLeads((prevLeads) =>
                prevLeads.map((lead) =>
                    lead.id === id
                        ? { ...lead, enabled_location: newValue }
                        : lead
                )
            );

        } catch (err) {
            console.error(err);

            // ❌ ERROR ALERT
            alert("❌ Failed to update location permission");
        }
    };

    // const filteredLeads = leads.filter((lead) =>
    //     (lead.full_name || "")
    //         .toLowerCase()
    //         .includes(search.toLowerCase())
    // );

    // 🎨 Styles

    // const filteredLeads = leads.filter((lead) =>
    //     (lead.full_name || "")
    //         .toLowerCase()
    //         .includes(search.toLowerCase())
    // );
    const filteredLeads = leads
        .filter((lead) =>
            (lead.full_name || "")
                .toLowerCase()
                .includes(search.toLowerCase())
        )

    // ✅ pagination logic
    const totalPages = Math.ceil(filteredLeads.length / itemsPerPage);

    // const paginatedLeads = filteredLeads.slice(
    //     (currentPage - 1) * itemsPerPage,
    //     currentPage * itemsPerPage
    // );

    const paginatedLeads = React.useMemo(() => {
        const start = (currentPage - 1) * itemsPerPage;
        return filteredLeads.slice(start, start + itemsPerPage);
    }, [filteredLeads, currentPage]);

    const styles = {
        container: {
            padding: "24px",
            fontFamily: "Arial",
        },
        header: {
            fontSize: "24px",
            fontWeight: "bold",
            marginBottom: "16px",
            color: "#0B1C3D",
        },
        searchBox: {
            display: "flex",
            alignItems: "center",
            marginBottom: "20px",
            maxWidth: "300px",
            position: "relative",
        },
        searchInput: {
            width: "100%",
            padding: "8px 12px 8px 35px",
            borderRadius: "8px",
            border: "1px solid #ccc",
        },
        searchIcon: {
            position: "absolute",
            left: "10px",
            color: "#888",
        },
        table: {
            width: "100%",
            borderCollapse: "collapse",
            borderRadius: "10px",
            overflow: "hidden",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        },
        th: {
            backgroundColor: "#8b306d",
            color: "white",
            padding: "12px",
            textAlign: "center",
        },
        td: {
            padding: "12px",
            textAlign: "center",
        },
        badge: {
            padding: "6px 12px",
            borderRadius: "20px",
            fontSize: "12px",
            fontWeight: "bold",
        },
        green: {
            backgroundColor: "#DCFCE7",
            color: "#166534",
        },
        red: {
            backgroundColor: "#FEE2E2",
            color: "#991B1B",
        },
        button: {
            padding: "6px 12px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "500",
        },
        sendBtn: {
            backgroundColor: "#16a34a",
            color: "white",
        },
        cancelBtn: {
            backgroundColor: "#dc2626",
            color: "white",
        },
        row: {
            transition: "0.2s",
        },
    };

    // useEffect(() => {
    //     setCurrentPage(1);
    // }, [search]);

    useEffect(() => {
        if (currentPage > totalPages) {
            setCurrentPage(totalPages || 1);
        }
    }, [filteredLeads]);

    console.log(projects)
    const [selectedProject, setSelectedProject] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openProjectModal = (propertyId) => {
        const project = projects.find(p => p.id === propertyId);

        if (project) {
            setSelectedProject(project);
            setIsModalOpen(true);
        } else {
            alert("Project not found");
        }
    };

    return (
        <div style={styles.container}>
            <h2 style={styles.header}>📍 Geolocation Permission</h2>

            {/* 🔍 Search */}
            <div style={styles.searchBox}>
                <Search size={18} style={styles.searchIcon} />
                <input
                    type="text"
                    placeholder="Search lead..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={styles.searchInput}
                />
            </div>

            {/* 📊 Table */}
            {loading ? (
                <p>Loading...</p>
            ) : (
                <>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.th}>Name</th>
                                <th style={styles.th}>Mobile</th>
                                <th style={styles.th}>Email</th>
                                <th style={styles.th}>Property</th>
                                <th style={styles.th}>Status</th>
                                <th style={styles.th}>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {paginatedLeads.map((lead, index) => (
                                <tr
                                    // key={lead.id}
                                    key={`${lead.id}-${index}`}
                                    style={{
                                        ...styles.row,
                                        background:
                                            index % 2 === 0
                                                ? "#ffffff"
                                                : "#f9fafb",
                                    }}
                                >
                                    <td style={styles.td}>{lead.full_name}</td>
                                    <td style={styles.td}>{lead.mobile_number}</td>
                                    <td style={styles.td}>{lead.email}</td>
                                    {/* <td style={styles.td}>{lead.property_id}</td> */}
                                    <td
                                        style={{ ...styles.td, color: "#2563eb", cursor: "pointer", fontWeight: "bold" }}
                                        onClick={() => openProjectModal(lead.property_id)}
                                    >
                                        View Property
                                    </td>

                                    {/* ✅ STATUS BADGE */}
                                    <td style={styles.td}>
                                        <span
                                            style={{
                                                ...styles.badge,
                                                ...(lead.enabled_location === 1
                                                    ? styles.green
                                                    : styles.red),
                                            }}
                                        >
                                            {lead.enabled_location === 1
                                                ? "Request Sent"
                                                : "Waiting"}
                                        </span>
                                    </td>

                                    {/* ✅ ACTION BUTTON */}
                                    <td style={styles.td}>
                                        <button
                                            style={{
                                                ...styles.button,
                                                ...(lead.enabled_location === 1
                                                    ? styles.cancelBtn
                                                    : styles.sendBtn),
                                            }}
                                            onClick={() =>
                                                updateLocationPermission(
                                                    lead.id,
                                                    lead.enabled_location
                                                )
                                            }
                                        >
                                            {lead.enabled_location === 1
                                                ? "Cancel Request"
                                                : "Send Request"}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        marginTop: "15px",
                        gap: "10px"
                    }}>

                        <button
                            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                            style={{
                                padding: "6px 12px",
                                borderRadius: "6px",
                                border: "1px solid #ccc",
                                background: currentPage === 1 ? "#eee" : "#fff",
                                cursor: currentPage === 1 ? "not-allowed" : "pointer"
                            }}
                        >
                            Prev
                        </button>

                        <span style={{ fontWeight: "bold" }}>
                            {currentPage} / {totalPages || 1}
                        </span>

                        <button
                            onClick={() =>
                                setCurrentPage((prev) =>
                                    Math.min(prev + 1, totalPages)
                                )
                            }
                            disabled={currentPage === totalPages || totalPages === 0}
                            style={{
                                padding: "6px 12px",
                                borderRadius: "6px",
                                border: "1px solid #ccc",
                                background: currentPage === totalPages ? "#eee" : "#fff",
                                cursor: currentPage === totalPages ? "not-allowed" : "pointer"
                            }}
                        >
                            Next
                        </button>

                    </div>

                    {isModalOpen && selectedProject && (
                        <div style={modalStyles.overlay}>
                            <div style={modalStyles.modal}>

                                {/* ❌ Close Button */}
                                <button
                                    onClick={() => setIsModalOpen(false)}
                                    style={modalStyles.closeBtn}
                                >
                                    ✖
                                </button>

                                {/* 🏠 Title */} 
                                <h2 style={modalStyles.title}>{selectedProject.title}</h2>

                                {/* 📍 Location */}
                                <p><b>Location:</b> {selectedProject.location}</p>

                                {/* 💰 Price */}
                                <p><b>Price:</b> ₹{selectedProject.price}</p>

                                {/* 📐 Area */}
                                <p><b>Area:</b> {selectedProject.area} sqft</p>

                                {/* 🏷 Category */}
                                <p><b>Category:</b> {selectedProject.category}</p>

                                {/* 📄 Description */}
                                <p style={{ marginTop: "10px" }}>
                                    {selectedProject.description}
                                </p>

                                {/* 🖼 Images */}
                                <div style={modalStyles.imageContainer}>
                                    {selectedProject.property_images?.map((img, index) => (
                                        <img
                                            key={index}
                                            src={img}
                                            alt="property"
                                            style={modalStyles.image}
                                        />
                                    ))}
                                </div>

                            </div>
                        </div>
                    )}


                </>

            )}
        </div>
    );
};

const modalStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
    },
    modal: {
        background: "#fff",
        padding: "20px",
        borderRadius: "12px",
        width: "600px",
        maxHeight: "80vh",
        overflowY: "auto",
        position: "relative",
    },
    closeBtn: {
        position: "absolute",
        top: "10px",
        right: "10px",
        border: "none",
        background: "#ef4444",
        color: "#fff",
        borderRadius: "50%",
        width: "30px",
        height: "30px",
        cursor: "pointer",
    },
    title: {
        marginBottom: "10px",
        color: "#0B1C3D",
    },
    imageContainer: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
        gap: "10px",
        marginTop: "15px",
    },
    image: {
        width: "100%",
        height: "100px",
        objectFit: "cover",
        borderRadius: "8px",
    },
};

export default GeoLocationPermission;